<template>

<div class="virtual-car table-hook fadeInRight" v-loading="loading">
    <div class="title-box">
        <span class="m-title">虚拟卡列表</span>
        <el-form ref="cardForm" :model="cardForm" inline class="hook right themed-form search-form" :rules="rules">
            <el-form-item label="是否分销:" v-if="currentRole==0">
                <el-select v-model="cardForm.isdistribution" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已分销" value="yes"></el-option>
                    <el-option label="未分销" value="no"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态:">
                <el-select v-model="cardForm.status" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待激活" value="1"></el-option>
                    <el-option label="正常" value="2"></el-option>
                    <el-option label="断网" value="3"></el-option>
                    <el-option label="停机" value="4"></el-option>
                    <el-option label="异常" value="5"></el-option>
                    <el-option label="注销" value="7"></el-option>
                     <el-option label="冻结" value="11"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡片类型:">
                <el-select v-model="cardForm.type" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="包月" value="1"></el-option>
                    <el-option label="包年" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开卡公司:">
                <search-select :optionsMetaAll="accountLists" v-model="cardForm.accountId">
                </search-select>
            </el-form-item>
            <!-- <el-form-item label="分销商:">
                <el-input v-model="cardForm.agentThreeName"></el-input>
            </el-form-item> -->
              <el-form-item label="分销商:">
                <el-select v-model="cardForm.agentIds" multiple   :multiple-limit="2"  filterable>
					<el-option v-for="item in agentThreeLists" :key="item.index" :label="item.agentName" :value="item.agentId">
					</el-option>
				</el-select>
            </el-form-item>
            <!-- <el-form-item label="套餐">
                <el-input v-model="cardForm.setMealName"></el-input>
            </el-form-item> -->
            <el-form-item label="套餐">
                <el-select v-model="cardForm.setMealIds" multiple  filterable >
					<el-option v-for="(item,index) in setMealNameLists" :key="index" :label="item.mealName" :value="item.mealId">
					</el-option>
				</el-select>
            </el-form-item>
            <el-form-item label="接入号:">
                <el-input v-model="cardForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="ICCID号/短号">
                <el-input v-model="cardForm.iccidMark" class="iccid-width"></el-input>
            </el-form-item>
            <el-form-item label="实体卡号">
                <el-input v-model="cardForm.enIccidMark" class="iccid-width"></el-input>
            </el-form-item>
             <el-form-item label="短号号段:">
                <el-input v-model="cardForm.shortIccidStart" class="iccid-width"></el-input>
            </el-form-item>
            <el-form-item>至</el-form-item>
            <el-form-item><el-input v-model="cardForm.shortIccidEnd" class="iccid-width"></el-input></el-form-item>
            <el-form-item label="ICCID号段:">
                <el-input v-model="cardForm.iccidStart" class="iccid-width"></el-input>
            </el-form-item>
            <el-form-item>至</el-form-item>
            <el-form-item><el-input v-model="cardForm.iccidEnd" class="iccid-width"></el-input></el-form-item>
            <el-form-item label="导入时间:">
                <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="cardForm.startTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item>至</el-form-item>
            <el-form-item>
                <el-date-picker placeholder="选择日期" value-format="yyyy-MM-dd" v-model="cardForm.endTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="导入批次:">
                <el-input v-model="cardForm.importNum"></el-input>
            </el-form-item>
            <el-form-item label="激活时间:">
                <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="cardForm.servstartTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item>至</el-form-item>
            <el-form-item>
                <el-date-picker placeholder="选择日期" value-format="yyyy-MM-dd" v-model="cardForm.servendTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="到期时间:">
                <el-select v-model="cardForm.expireMonth" placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="一个月" value="1"></el-option>
                    <el-option label="二个月" value="2"></el-option>
                    <el-option label="三个月" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="IMEI:">
                <el-input v-model="cardForm.imei"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
                <el-input v-model="cardForm.remark"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="reloadPageData">搜索查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-download" class="themed-button" @click="exportExcel">导出excel</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="addRecord">网卡分销</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="cardBatchRechage">批量充值</el-button>
            </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="cardPropertySetting" v-if="currentRole==0" >卡属性设置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-s-claim" class="themed-button" @click="recycleSim">网卡回收</el-button>
            </el-form-item>
            <el-form-item>
				<el-popover
					placement="bottom"
							trigger="click">
							<div style="width:149px; line-height:22px;overflow-y:auto;max-height:350px">
									<p style="margin-bottom:10px">筛选条件</p>
                                    <el-checkbox v-model="checkList[0]">短号</el-checkbox>
                                    <el-checkbox v-model="checkList[1]">接入号码</el-checkbox>
									<el-checkbox v-model="checkList[2]">IMEI</el-checkbox>
									<el-checkbox v-model="checkList[3]">开卡公司</el-checkbox>
									<el-checkbox v-model="checkList[4]">导入时间</el-checkbox>
									<el-checkbox v-model="checkList[5]">套餐总流量</el-checkbox>
									<el-checkbox v-model="checkList[6]">已使用流量</el-checkbox>
									<el-checkbox v-model="checkList[7]">剩余流量</el-checkbox>
									<el-checkbox v-model="checkList[8]">激活时间</el-checkbox>
									<el-checkbox v-model="checkList[9]">导入批次</el-checkbox>
									<el-checkbox v-model="checkList[10]">到期时间</el-checkbox>
									<el-checkbox v-model="checkList[11]">套餐</el-checkbox>
									<el-checkbox v-model="checkList[12]">卡片类型</el-checkbox>
                                    <el-checkbox v-model="checkList[13]">总代理</el-checkbox>
                                    <el-checkbox v-model="checkList[14]">分销商姓名</el-checkbox>
                                    <el-checkbox v-model="checkList[15]">卡状态</el-checkbox>
                                    <el-checkbox v-model="checkList[16]">是否实名</el-checkbox>
								</div>
							<el-button slot="reference" icon="el-icon-finished"></el-button>
						</el-popover>
			</el-form-item>
        </el-form>
    </div>
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight" 
        row-key="id"
         lazy
        :load="loadData"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column label="ICCID号" width="280px">
                <template slot-scope="scope">
                   <a href="javascript:void(0)" @click="detailDate(scope.row)">{{scope.row.iccidMark}}</a>
               </template>
            </el-table-column>
            <el-table-column label="短号" prop="shortIccid" show-overflow-tooltip v-if="checkList[0]"/>
            <el-table-column label="接入号码" prop="phone" show-overflow-tooltip v-if="checkList[1]"></el-table-column>
            <el-table-column
              label="写号状态"
              prop="writeStatus"
              show-overflow-tooltip
              v-if="((cardForm.phone && cardForm.phone.trim() !== '') || (cardForm.iccidMark && cardForm.iccidMark.trim() !== '') || (cardForm.enIccidMark && cardForm.enIccidMark.trim() !== '') )&& showVirtualCardWriteDetail === '1'"
            >
              <template slot-scope="scope">
                <span>{{ getWriteStatusText(scope.row.writeStatus) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="是否Esim"
              prop="writeStatusString"
              show-overflow-tooltip
              v-if="((cardForm.phone && cardForm.phone.trim() !== '') || (cardForm.iccidMark && cardForm.iccidMark.trim() !== '') || (cardForm.enIccidMark && cardForm.enIccidMark.trim() !== '')) && showVirtualCardWriteDetail === '1'"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.writeStatusString ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="IMEI" prop="imei" show-overflow-tooltip v-if="checkList[2]">
                <template slot-scope="scope">
                  <template v-if="((cardForm.phone && cardForm.phone.trim() !== '') || (cardForm.iccidMark && cardForm.iccidMark.trim() !== '') || (cardForm.enIccidMark && cardForm.enIccidMark.trim() !== '')) && showVirtualCardWriteDetail === '1'">
                    <a href="javascript:void(0)" @click="goToDeviceList(scope.row.imei)">{{scope.row.imei}}</a>
                  </template>
                  <template v-else>
                    <span>{{scope.row.imei}}</span>
                  </template>
                </template>
            </el-table-column>
            <el-table-column label="开卡公司" prop="accountName" show-overflow-tooltip v-if="checkList[3]"></el-table-column>
            <el-table-column label="导入时间" show-overflow-tooltip v-if="checkList[4]">
               <template slot-scope="scope">
                   <span>{{createDateTime(scope.row.createDateTime)}}</span>
               </template>
            </el-table-column>
              <el-table-column label="套餐总流量" prop="flowSize" show-overflow-tooltip v-if="checkList[5]">
                <template slot-scope="scope">
                    <span v-if="scope.row.flowSize">{{parseFloat(scope.row.flowSize).toFixed(2) + 'MB'}}</span>
                    <span v-else-if="!scope.row.flowSize">-</span>
                </template>
            </el-table-column>
             <el-table-column label="已使用流量" prop="totalBytesCnt" show-overflow-tooltip v-if="checkList[6]">
                <template slot-scope="scope">
                    <span v-if="scope.row.totalBytesCnt">{{parseFloat(scope.row.totalBytesCnt).toFixed(2)+"MB"}}</span>
                    <span v-else-if="!scope.row.totalBytesCnt">-</span>
                </template>
            </el-table-column>
             <el-table-column label="剩余流量" prop="" show-overflow-tooltip v-if="checkList[7]">
                <template slot-scope="scope">
                    <span v-if="(scope.row.flowSize - scope.row.totalBytesCnt)">{{parseFloat(scope.row.flowSize - scope.row.totalBytesCnt).toFixed(2) +'MB'}}</span>
                    <span v-else-if="!(scope.row.flowSize - scope.row.totalBytesCnt)">-</span>
                </template>
            </el-table-column>
            <el-table-column label="激活时间" prop="servCreateDate" show-overflow-tooltip v-if="checkList[8]">
                <template slot-scope="scope">
                    <span v-if="scope.row.servCreateDate">{{scope.row.servCreateDate.substring(0,10)}}</span>
                    <span v-else-if="!scope.row.servCreateDate">-</span>
                </template>
            </el-table-column>
            <el-table-column label="导入批次" prop="importNum" show-overflow-tooltip v-if="checkList[9]"></el-table-column>
            <el-table-column label="到期时间" prop="expirationDate" show-overflow-tooltip v-if="checkList[10]"></el-table-column>
            <el-table-column label="套餐" prop="setMealName" show-overflow-tooltip v-if="checkList[11]"></el-table-column>
            <el-table-column label="卡片类型" prop="type" v-if="checkList[12]">
                <template slot-scope="scope">
                    <span v-if="scope.row.type===1">包月</span>
                    <span v-else-if="scope.row.type===2">包年</span>
                </template>
            </el-table-column>
            <el-table-column label="总代理" prop="agentTopName" show-overflow-tooltip v-if="checkList[13]"></el-table-column>
            <el-table-column label="分销商姓名" prop="agentThreeName" show-overflow-tooltip v-if="checkList[14]"></el-table-column>
            <el-table-column label="卡状态" prop="statusString" v-if="checkList[15]"></el-table-column>
            <el-table-column label="是否实名" prop="isRealName" show-overflow-tooltip v-if="checkList[16]">
                <template slot-scope="scope">
                    <span v-if="scope.row.isRealName === 1 || scope.row.isRealName === '1'">已实名</span>
                    <span v-else-if="scope.row.isRealName === 0 || scope.row.isRealName === '0'">未实名</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark"></el-table-column>
            <!-- <el-table-column label="余额" prop="balance"></el-table-column> -->
            <el-table-column label="操作" width="80px">
                <template slot-scope="scope">
                    <el-button type="danger" class="themed-button" @click="delectDate(scope.row.iccidMark)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pagination">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15, 50,100,1000]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>

    
    <el-dialog title="网卡分销" :visible.sync="dialogDistributionCard">
        <el-form label-position="right" label-width="200px" :model="setPackageForm" ref="setPackageForm">
            <el-form-item label="代理商:" >
                <search-select :optionsMetaAll="agentList" v-model="setPackageForm.agentList">
                </search-select>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" class="themed-button" @click="recordSave">确定</el-button>
            <el-button type="primary" class="themed-button" @click="dialogDistributionCard = false">取 消</el-button>
        </div>
    </el-dialog>

    <el-dialog title="批量充值" :visible.sync="dialogCardBatchRechage">
        <el-form label-position="right" label-width="200px" :model="cardBatchRechageForm" ref="cardBatchRechageForm">
            <el-form-item label="套餐:" >
                <search-select :optionsMetaAll="setMeal" v-model="cardBatchRechageForm.packageIds">
                </search-select>
            </el-form-item>
        </el-form>
         <div style="color:#f00">
            注意：批量充值卡片只能充值同样的套餐，非同一个运营商的卡请不要混和操作，单次操作请不要超过5W张，否则会引起系统卡顿
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" class="themed-button" @click="rechargeSave">确定</el-button>
            <el-button type="primary" class="themed-button" @click="dialogCardBatchRechage = false">取 消</el-button>
        </div>
    </el-dialog>

</div>

</template>

<script type="text/ecmascript-6">
import {
  getDictGroupList,
} from "@/api/operator.js";
import {
  deviceList,
} from "@/api/devices/devices.js";
    import {getAccountList,checkExportVirtualCount,getagentList,distributionCard,getSetMealOne,batchRecharge,cardRecycleByExcel,findCardInfo,deleteCard,setmealListForUser,agentListForUser} from '@/api/cardManagement/cardBill.js'
    import {invCardList,findInvCardInfo,invListWithVO} from '@/api/virtualCard/accountRateList.js'
    import {mapGetters} from 'vuex'
    import {messageBox,confirmBox } from '@/utils/common.js'
    import SearchSelect from '@/components/SearchSelect'
    import loading from '@/utils/Loading.js'
    import resize from '@/mixins/resize.js'
    import storage from '@/utils/storage.js'

    import {mapMutations} from "vuex"

    const ERR_OK = 0
    export default {
        name:'virtualCardList',
        mixins:[resize],
        data(){
            return {
                 setMealNameLists:[],
                agentThreeLists:[],
                loading:false,
                showVirtualCardWriteDetail: '', // 存储找到的 dictValue 值
                cardForm:{
                    invType:'2',
                    isdistribution:'',
                    status:'',
                    type:'',
                    accountId:'',
                    agentThreeName:'',
                    setMealName:'',
                    phone:'',
                    iccidMark:'',
                    iccidStart:'',
                    iccidEnd:'',
                    startTime:'',
                    endTime:'',
                    importNum:'',
                    servstartTime:'',
                    servendTime:'',
                    expireMonth:'',
                    imei:'',
                    enIccidMark:'',
                    shortIccidStart:"",
                    shortIccidEnd:"",
                    agentIds:"",
                    setMealIds:"",
                    remark:"",
                },
                rules:{
                    iccidMark:[
                        { required: true, message: 'ICCID号不能为空', trigger: 'blur' }
                    ],
                    iccidStart:[
                        { required: true, message: 'ICCID号段不能为空', trigger: 'blur' }
                    ],
                    iccidEnd:[
                        { required: true, message: 'ICCID号段不能为空', trigger: 'blur' }
                    ],
                },
                accountLists:[{label:'请选择',value:''}],
                tableData:[],
                pageSize:15,
                currentPage:1,
                total:0,
                dialogDistributionCard:false,
                setPackageForm:{
                    "agentList":[]
                },
                agentList:[],
                cardBatchRechageForm:{
                    packageIds:''
                },
                dialogCardBatchRechage:false,
                setMeal:[],
                checkList:[]
            }
        },
        mounted(){
            this._getDictGroupList()
            this._getAccountList()
            this._invCardList()
             this.getAgentListForUser()
            this.getSetmealListForUser()
             try{
               console.log("诺行版权")
            }catch(error){
               console.log("notioni:"+error)
            }
        },
        created(){
            let list = []
			for (let index = 0; index < 17; index++) {
				list.push(true)
			}
			let checkList = ""
			if(storage.support){
				checkList = storage.get("virtualCardCheckList")
				if(!checkList){
					this.checkList = list
					storage.set("virtualCardCheckList",JSON.stringify(list))
				}else{
					this.checkList = JSON.parse(checkList)
					// 兼容旧数据长度不足的情况，自动补齐到 17 位
					if (Array.isArray(this.checkList) && this.checkList.length < 17) {
						for (let i = this.checkList.length; i < 17; i++) {
							this.checkList.push(true)
						}
						storage.set("virtualCardCheckList", JSON.stringify(this.checkList))
					}
				}
			}else{
				this.checkList = list
			}
            try{
               let test = null
               test.forEach(item=>{
                console.log(item)
               }) 
               
            }catch(error){
               console.log("notioni:"+error)
            }
        },
        watch:{
			checkList: function(newValue, old){
				if(storage.support){
					storage.set("virtualCardCheckList",JSON.stringify(newValue))
				}
			}
		},
        methods:{
            _getDictGroupList() {
              let params = {
                dictGroup: "WRITECARD_GROUP",
                type: "1",
             };
            getDictGroupList(params).then((res) => {
                console.log(res.WRITECARD_GROUP);
                
                // 遍历 WRITECARD_GROUP 数组，找到 dictKey 为 SHOW_VIRTUAL_CARD_WRITE_DETAIL 的元素
                if (res.WRITECARD_GROUP && Array.isArray(res.WRITECARD_GROUP)) {
                    const targetItem = res.WRITECARD_GROUP.find(item => item.dictKey === 'SHOW_VIRTUAL_CARD_WRITE_DETAIL');
                    if (targetItem) {
                        console.log('找到目标元素:', targetItem);
                        console.log('dictValue 值:', targetItem.dictValue);
                        // 可以将 dictValue 保存到组件的数据中
                        this.showVirtualCardWriteDetail = targetItem.dictValue;
                    } else {
                        console.log('未找到 dictKey 为 SHOW_VIRTUAL_CARD_WRITE_DETAIL 的元素');
                    }
                }
           
           });
           },
            ...mapMutations(
                ["SET_ICCID_OR_PHONE_V"]
            ),
            loadData(tree, treeNode, resolve){
                const hasPhone = this.cardForm.phone && this.cardForm.phone.trim() !== '';
                const hasIccidMark = this.cardForm.iccidMark && this.cardForm.iccidMark.trim() !== '';
                const hasEnIccidMark = this.cardForm.enIccidMark && this.cardForm.enIccidMark.trim() !== '';
                const showDetail = this.showVirtualCardWriteDetail === '1';
                if((hasPhone || hasIccidMark || hasEnIccidMark) && showDetail){
                    invListWithVO({invNo:tree.iccidMark}).then((r)=>{
                    console.log(r,324)
                    resolve(r.rows)
                })
                }else{
                    invCardList({invNo:tree.iccidMark}).then((r)=>{
                    console.log(r,324)
                    resolve(r.rows)
                })
                }
                
            },
                getAgentListForUser(){
             agentListForUser().then(res=>{
                console.log(391)
                this.agentThreeLists = res
             })
            },
            getSetmealListForUser(){
              setmealListForUser().then(res=>{
                console.log(396)
                this.setMealNameLists = res
             })
            },
            createDateTime(createDateTime){
                return createDateTime.substr(0,4)+"-"+createDateTime.substr(4,2)+"-"+createDateTime.substr(6,2)+
                " "+createDateTime.substr(8,2)+":"+createDateTime.substr(10,2)+":"+createDateTime.substr(12,2); 
            },
            detailDate(row){
                // 处理 iccidMark，去掉括号及其内容
                let iccid = row.iccidMark ? row.iccidMark.replace(/\(.*\)$/,'') : '';
               

                this.SET_ICCID_OR_PHONE_V(iccid)
                this.$router.push({
                        path: '/virtualCard/virtualCardDetail',
                        query: {
                            iccidOrPhone: iccid
                        }
                })

            },
            delectDate(iccidMark){
                this.delect_iccidMark = iccidMark
                confirmBox(this,iccidMark+": 确定要删除吗?",'操作提示',()=>{
                    deleteCard({'iccid':iccidMark}).then((res)=>{
                        messageBox(this,'操作成功')
                        this._invCardList()
                    })
                })
            },
            reloadPageData(){
                this._invCardList("search")
            },
            exportExcel(){
                this._checkExportCount()
            },
            addRecord(){
                if(!this._checkIccid()){
                    return
                }
                this.dialogDistributionCard = true
                getagentList(this.cardForm).then((res) => {
                    if(res.length>0){
                        this.agentList = res.map((item)=>{
                            return {
                                label:item.name,
                                value:item.id
                            }
                        })
                    }else{
                        this.agentList = []
                    }
                    
                })
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val
                this._invCardList()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val
                this._invCardList()
            },
            recordSave(){
                let params = {}
                Object.assign(params, this.cardForm)
                Object.assign(params, this.setPackageForm)
                distributionCard(params).then((res) => {
                    messageBox(this,'分销成功','网卡分销')
                    this.dialogDistributionCard = false
                    this._invCardList()
                    
                })
            },
            cardBatchRechage(){
                if(!this._checkIccid()){
                    return
                }
                this.dialogCardBatchRechage = true
                
                getSetMealOne(this.cardForm).then((res) => {
                    this.setMeal = res.map((value,index,arr)=>{
                        return {value:value.id,label:value.name}
                    })
                })
            },
            cardPropertySetting(){
             this.$router.push({
						path:'/virtualCard/cardPropertySetting'
					})
            },
            rechargeSave(){
                let params = {}
                Object.assign(params, this.cardForm)
                Object.assign(params, this.cardBatchRechageForm)
                batchRecharge(params).then((res) => {
                    messageBox(this,'充值成功','批量充值')
                    this.dialogCardBatchRechage = false
                })
            },
            recycleSim(){
                if(!this._checkIccid()){
                    return
                }
                let that = this
                messageBox(that,'确定要进行回收吗？','网卡回收',this._cardRecycleByExcel)
            },
            _cardRecycleByExcel(){
                let params = {fromRange:true}
                cardRecycleByExcel(Object.assign(params, this.cardForm)).then((res) => {
                    if(res.isSuccess === "1"){
                        messageBox(this,'回收完成','网卡回收')
                    }
                    this.$router.push('/historyRecord/NICrRecovery')
                })
            },
            _invCardList(str){
                this.loading = true
                // 检查是否满足展开条件
                const hasPhone = this.cardForm.phone && this.cardForm.phone.trim() !== '';
                const hasIccidMark = this.cardForm.iccidMark && this.cardForm.iccidMark.trim() !== '';
                const hasEnIccidMark = this.cardForm.enIccidMark && this.cardForm.enIccidMark.trim() !== '';
                const showDetail = this.showVirtualCardWriteDetail === '1';
                let params = {}
                params.pageSize = this.pageSize
                if(str == "search"){
                params.pageNo = 1
                }else{
                params.pageNo = this.currentPage
                }
                
                Object.assign(params, this.cardForm)
                // invCardList(params).then((res)=>{
                //     this.loading = false
                //     this.total = res.total
                //     this.currentPage = res.pageNo
                //     this.pageSize = res.pageSize
                //     this.tableData = res.rows
                    
                //     // 检查是否需要展开树形数据
                //     this.$nextTick(() => {
                //         this.checkAndExpandTreeData();
                //     });
                // })
                if ((hasPhone || hasIccidMark || hasEnIccidMark) && showDetail) {
                    // 展开所有树形数据
                    invListWithVO(params).then((res)=>{
                    this.loading = false
                    this.total = res.total
                    this.currentPage = res.pageNo
                    this.pageSize = res.pageSize
                    this.tableData = res.rows
                    
                    // 检查是否需要展开树形数据
                    this.$nextTick(() => {
                        this.checkAndExpandTreeData();
                    });
                })
                }else{
                    invCardList(params).then((res)=>{
                    this.loading = false
                    this.total = res.total
                    this.currentPage = res.pageNo
                    this.pageSize = res.pageSize
                    this.tableData = res.rows
                    
                    // 检查是否需要展开树形数据
                    this.$nextTick(() => {
                        this.checkAndExpandTreeData();
                    });
                })
                }
              

            },
            _getAccountList(){
                getAccountList().then((res) => {
                    this.accountLists = [{label:'请选择',value:''}]
                    if(res.length>0){
                        res.forEach((item)=>{
                            this.accountLists.push({label:item.accountName,value:item.id})
                        })
                    }
                })
            },
            _checkExportCount(){
                let params = this.cardForm
				params.includeFields = this.checkList.join(',')
                checkExportVirtualCount(params).then(res=>{
					if (res.system_result_key == '0') {
						this.$alert('导出成功，请到导出记录中下载', '提示', {
						    confirmButtonText:'确定',
						}).then(()=>{
							this.$router.push('/tob/i_export_list')
						});
					}else{
						this.$message({
						    showClose: true,
						    message: res.system_result_message_key,
						    type: 'error'
						});
					}
				})
            },
            checkAndExpandTreeData() {
                // 检查是否满足展开条件
                const hasPhone = this.cardForm.phone && this.cardForm.phone.trim() !== '';
                const hasIccidMark = this.cardForm.iccidMark && this.cardForm.iccidMark.trim() !== '';
                const hasEnIccidMark = this.cardForm.enIccidMark && this.cardForm.enIccidMark.trim() !== '';
                const showDetail = this.showVirtualCardWriteDetail === '1';
                
                // 如果满足条件：存在搜索条件且 showVirtualCardWriteDetail 为 "1"
                if ((hasPhone || hasIccidMark || hasEnIccidMark) && showDetail) {
                    // 展开所有树形数据
                    this.expandAllTreeData();
                }
            },
            
            expandAllTreeData() {
                // 获取表格实例
                const table = this.$refs.table;
                if (!table) return;
                
                console.log(this.tableData)
                
                // 使用 Promise 来处理异步加载
                const expandPromises = [];
                
                // 遍历表格数据，展开所有有子节点的行
                this.tableData.forEach((row, index) => {
                    if (row.hasChildren) {
                        const expandPromise = new Promise((resolve) => {
                            // 先调用 loadData 获取子节点数据
                            this.loadData(row, null, (children) => {
                                // 子节点数据加载完成后，展开该行
                                if (children && children.length > 0) {
                                    // 将子节点数据添加到行数据中
                                    this.$set(row, 'children', children);
                                    // 展开行
                                    table.toggleRowExpansion(row, true);
                                }
                                resolve();
                            });
                        });
                        expandPromises.push(expandPromise);
                    }
                });
                
                // 等待所有子节点加载完成
                Promise.all(expandPromises).then(() => {
                    console.log('已展开树形数据，满足条件：存在搜索条件且 showVirtualCardWriteDetail 为 "1"');
                });
            },
            
            _checkIccid(){
                let that = this
              if((this.cardForm.iccidStart === '' || this.cardForm.iccidEnd === '')&&(this.cardForm.shortIccidStart === '' || this.cardForm.shortIccidEnd === '')){
                    messageBox(that,'ICCID/短号号段不能为空','网卡卡台账单')
                    return false
                }
                if(this.cardForm.iccidStart !=""  &&this.cardForm.iccidEnd !=""&&this.cardForm.iccidStart > this.cardForm.iccidEnd){
                    messageBox(that,'ICCID结束号段小于开始号段','网卡卡台账单')
                    return false
                }
                  let r = /^[0-9a-zA-Z]+$/
                  if(this.cardForm.iccidStart !=""  &&this.cardForm.iccidEnd !=""){
                 if(!r.test(this.cardForm.iccidStart) || !r.test(this.cardForm.iccidEnd)){
                messageBox(this,'ICCID只能包含数字和字母','网卡卡台账单')
                  return false
				}
                  }

                  if(this.cardForm.shortIccidStart !=""  &&this.cardForm.shortIccidEnd !=""&&this.cardForm.shortIccidStart > this.cardForm.shortIccidEnd){
                    messageBox(that,'短号结束号段小于开始号段','网卡卡台账单')
                    return false
                }
                  let m = /^[0-9]+$/
                  if(this.cardForm.shortIccidStart !=""  &&this.cardForm.shortIccidEnd !=""){
                 if(!m.test(this.cardForm.shortIccidStart) || !m.test(this.cardForm.shortIccidEnd)){
                messageBox(this,'短号只能包含数字和字母','网卡卡台账单')
                  return false
				}
                  }
                return true
            },
            getWriteStatusText(status) {
                switch (status) {
                    case 0:
                    case '0':
                        return '待写号';
                    case 1:
                    case '1':
                        return '写号中';
                    case 2:
                    case '2':
                        return '已写号';
                    case 3:
                    case '3':
                        return '写号失败';
                    default:
                        return '-';
                }
            },
            goToDeviceList(imei) {

                if (!imei) return;
                let params = {
        pageNum: 15,
        pageSize: 1,
        imei:imei,
        iccid_shortNo:"",
        status:"",
        softwareVersion:"",
        model:"",
        offline_time_start:"",
        offline_time_end:"",
        sn:"",
      };
      deviceList(params).then((res) => {
        let tableData1 = res.rows;
        if (!tableData1 || tableData1.length === 0) {
          this.$message.warning("imei未导入设备列表");
          return;
        }
        // 这里可以继续后续逻辑
        console.log(tableData1)
        
        this.$router.push({
        path: "/equipmentManagement/operationsManagement",
        query: { data: JSON.stringify(tableData1[0]) },
      });
        
      
      });

            }
        },
        components:{
            SearchSelect
        },
         computed:{
        	...mapGetters(
            	['currentRole']
        	),
    	},
    }
</script>

<style>
    .virtual-car{position:relative;}
    .virtual-car .el-table .cell{height:23px;}
</style>
